import { isSavage } from '~/shared/utils/brandNameHelper';

import {
  RESERVED_SPACE_FOR_CARD_INFO,
  RESERVED_SPACE_FOR_CARD_INFO_SAVAGE_MOBILE,
} from '../constants';

import { getProductImageAspectRatio } from './images';

/**
 * Returns the height of a single cell in the grid layout.
 *
 * @param {Object} params - The parameters for calculating the cell height.
 * @param {boolean} params.isMobile - Indicates if the device is mobile.
 * @param {number} params.dynamicCardWidth - The dynamic width of the card.
 * @returns {number} - The calculated height of the cell in pixels.
 */
export const getCellHeight = ({ isMobile, dynamicCardWidth }) => {
  const productImageAspectRatio = 1 / getProductImageAspectRatio(isMobile); // reverse to get height/width instead of width/height
  const dynamicProductCardImageHeight =
    dynamicCardWidth * productImageAspectRatio;
  const reservedSpace =
    isSavage && isMobile
      ? RESERVED_SPACE_FOR_CARD_INFO_SAVAGE_MOBILE
      : RESERVED_SPACE_FOR_CARD_INFO;
  const cellHeight = dynamicProductCardImageHeight + reservedSpace;

  return cellHeight;
};
